import SelaTranscriptHover from './component.jsx'
export default SelaTranscriptHover
